"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApWidgetBadge = exports.ApWidgetBadgeTypes = void 0;
var React = require("react");
var theme_1 = require("../../../utils/theme");
var styles_1 = require("./styles");
var ApWidgetBadgeTypes;
(function (ApWidgetBadgeTypes) {
    ApWidgetBadgeTypes["oxr"] = "oxr";
    ApWidgetBadgeTypes["sxr"] = "sxr";
    ApWidgetBadgeTypes["chc"] = "chc";
    ApWidgetBadgeTypes["txr"] = "txr";
})(ApWidgetBadgeTypes = exports.ApWidgetBadgeTypes || (exports.ApWidgetBadgeTypes = {}));
var APP_COLORS = {
    chc: theme_1.colors.orange,
    oxr: theme_1.colors.blue1,
    sxr: theme_1.colors.green4,
    txr: theme_1.colors.red4,
    tsxr: theme_1.colors.red4,
};
exports.ApWidgetBadge = function (_a) {
    var type = _a.type, color = _a.color, className = _a.className;
    return (React.createElement(styles_1.Wrapper, { className: "ap-widget-badge " + (className ? className : ''), type: type, color: color || APP_COLORS[type] }, type));
};
//# sourceMappingURL=ApWidgetBadge.js.map